export default __webpack_public_path__ + "static/media/medaille-bdo-argent-usage.da9024c3.png";